/**
 * WORLD helpers — userData tagging per CONTRACTS.md, plus mesh conveniences.
 *
 * Contract keys: `solid: boolean`, `interactId?: string`.
 * Additive keys (documented deviation): `interactKind`, `interactPrompt`,
 * `interactRadius`, `clueId` — so PLAYER can build a full InteractTarget
 * from the raycast hit, and `bloom: true` on emissive meshes so RENDER can
 * do selective bloom.
 */
import type { Mesh, Object3D } from 'three'
import type { InteractKind } from '../core/types'

export interface InteractTag {
  readonly id: string
  readonly kind: InteractKind
  readonly prompt: string
  readonly radius: number
  readonly clueId?: string
}

const DEFAULT_INTERACT_RADIUS = 2.5

export const tagSolid = (object: Object3D): void => {
  object.userData['solid'] = true
}

export const tagInteract = (object: Object3D, tag: InteractTag): void => {
  object.userData['interactId'] = tag.id
  object.userData['interactKind'] = tag.kind
  object.userData['interactPrompt'] = tag.prompt
  object.userData['interactRadius'] = tag.radius
  if (tag.clueId !== undefined) {
    object.userData['clueId'] = tag.clueId
  }
}

export const tagBloom = (object: Object3D): void => {
  object.userData['bloom'] = true
}

export const interactRadius = (): number => DEFAULT_INTERACT_RADIUS

export const enableShadows = (mesh: Mesh): Mesh => {
  mesh.castShadow = true
  mesh.receiveShadow = true
  return mesh
}
